module.exports = __webpack_public_path__ + "static/madras-0a8f49e853ff2ece25ae8ed6ba1164f1.png";